import React from "react";
import "../styles/privacy.css";

const Terms = () => {
  return (
    <div className="privacy">
      <div className="privacy__container">
        <h1>Terms of Service</h1>
        <p className="privacy__last-updated">Effective Date: 03/04/2025</p>
        <div className="privacy__content">
          <p className="privacy__intro">
            Welcome to QRSharp ("we", "us", or "our"). By accessing or using our
            website (https://www.qrsharp.com) and services, you agree to comply
            with and be bound by the following Terms of Service ("Terms").
            Please read them carefully.
          </p>

          <section className="privacy__section">
            <h2>1. Account Registration</h2>
            <p>
              To use QRSharp's features, including QR code creation and
              analytics, you must create an account by providing a valid email
              address and password. You agree to:
            </p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the confidentiality of your login credentials</li>
              <li>Be responsible for all activities under your account</li>
            </ul>
            <p>
              We reserve the right to suspend or terminate your account if any
              information provided is inaccurate or if your activity violates
              these Terms.
            </p>
          </section>

          <section className="privacy__section">
            <h2>2. Use of the Service</h2>
            <p>
              QRSharp allows users to generate QR codes that redirect to website
              URLs and provides analytics about those scans. You agree to use
              the service only for lawful purposes.
            </p>
            <p>You must not:</p>
            <ul>
              <li>
                Use QRSharp to link to malicious, illegal, or harmful content
              </li>
              <li>
                Attempt to reverse engineer or interfere with our services
              </li>
              <li>Use QRSharp for spam or phishing activities</li>
            </ul>
          </section>

          <section className="privacy__section">
            <h2>3. Payment and Billing</h2>
            <p>
              Certain features of QRSharp may be offered as paid services.
              Payments are processed securely via Stripe. By subscribing or
              making a payment, you agree to:
            </p>
            <ul>
              <li>Provide accurate billing information</li>
              <li>
                Authorize Stripe to charge your payment method for the
                applicable fees
              </li>
            </ul>
            <p>All payments are non-refundable unless otherwise stated.</p>
          </section>

          <section className="privacy__section">
            <h2>4. Data and Privacy</h2>
            <p>
              We take your privacy seriously. By using QRSharp, you agree to our
              Privacy Policy, which explains how we collect, use, and protect
              your information.
            </p>
            <p>
              You retain ownership of the URLs and QR codes you create. We do
              not track scanners personally, and QRSharp analytics are
              aggregate-based.
            </p>
          </section>

          <section className="privacy__section">
            <h2>5. Account Termination</h2>
            <p>
              You may request deletion of your account and associated data at
              any time by contacting us at Support@QRSharp.com. We reserve the
              right to suspend or terminate accounts for violations of these
              Terms or misuse of the service.
            </p>
          </section>

          <section className="privacy__section">
            <h2>6. Intellectual Property</h2>
            <p>
              All content, branding, design, and technology used in QRSharp are
              the property of QRSharp and are protected by intellectual property
              laws. You may not copy, modify, or distribute any part of QRSharp
              without written consent.
            </p>
          </section>

          <section className="privacy__section">
            <h2>7. Service Availability</h2>
            <p>
              While we strive to keep QRSharp available at all times, we do not
              guarantee uninterrupted or error-free service. We may perform
              maintenance or make changes to the platform at any time.
            </p>
          </section>

          <section className="privacy__section">
            <h2>8. Limitation of Liability</h2>
            <p>
              QRSharp is provided "as is" without warranties of any kind. To the
              fullest extent permitted by law, we disclaim all liability for any
              indirect, incidental, or consequential damages arising from your
              use of the service.
            </p>
          </section>

          <section className="privacy__section">
            <h2>9. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of the
              service after any such updates constitutes acceptance of the
              revised Terms. Please review this page periodically.
            </p>
          </section>

          <section className="privacy__section">
            <h2>10. Contact Us</h2>
            <p>
              If you have questions about these Terms, please contact us at:
            </p>
            <p className="privacy__contact">Support@QRSharp.com</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
